import { Num, T, useGT } from 'gt-react';
import { UPLOAD_COLUMNS } from '@erp/rpc';

import { VirtualizedTable } from '@/components/xlsx-viewer/VirtualizedTable';
import type { UploadLine } from './resultsToUpload';
import { uploadPreviewSheet } from './skippedSheet';
import { useRuleText } from './useRuleText';

/** About 25 rows of 24px; it scrolls inside this. */
const PREVIEW_HEIGHT = 620;

/** The upload CSV that will be downloaded, in a spreadsheet grid. */
export function UploadPreview({ lines }: { lines: UploadLine[] }) {
  const gt = useGT();
  const { columnLabel } = useRuleText();
  if (lines.length === 0) return null;
  const sheet = uploadPreviewSheet(
    lines,
    UPLOAD_COLUMNS.map(columnLabel),
    gt('Upload preview', { context: 'name of the upload CSV preview grid' }),
  );
  return (
    <div className="flex flex-col gap-1">
      <h3 className="text-sm font-medium">
        <T context="heading over the grid previewing the upload CSV">
          Upload preview — <Num>{lines.length}</Num> lines, as UPLOAD.csv will
          contain them
        </T>
      </h3>
      <div className="overflow-hidden rounded-md border">
        <VirtualizedTable sheet={sheet} height={PREVIEW_HEIGHT} />
      </div>
    </div>
  );
}
